// extracted by mini-css-extract-plugin
module.exports = {"jds-CardImage":"cardImage_jds-CardImage__I_GO2","jds-CardImage__image":"cardImage_jds-CardImage__image__jS8zd"};